import { MyModulesNoResults } from '@pickleballinc/ui/components/global/myModules/MyModulesNoResults';
import { useRouter } from 'next/navigation';

import { PlayerTournamentCard } from '@/modules/players/v2/tabs/components/PlayerTournamentCard';
import { getNoResultsConfig } from '@/modules/players/v2/tabs/helpers';
import { PlayerData } from '@/types/players.types';
import { PlayerTournamentsData } from '@/types/playerTournaments.types';

interface FavoriteTournamentsProps {
  data: PlayerTournamentsData[];
  player?: PlayerData;
  isUserAlsoPlayer?: boolean;
}

export function FavoriteTournaments({ data, player, isUserAlsoPlayer }: FavoriteTournamentsProps) {
  const router = useRouter();

  const noResultsConfig = getNoResultsConfig({
    moduleType: 'tournament',
    isManage: false,
    isRegistered: false,
    player,
    isUserAlsoPlayer,
  });

  return data && data.length > 0 ? (
    <div className='mb-6 mt-0 sm:mt-4 grid grid-cols-1 gap-4 py-4 sm:grid-cols-2 md:gap-6 lg:grid-cols-4'>
      {data.map((tourney) => {
        return (
          <PlayerTournamentCard
            key={`tournament-favorite-card-${tourney.tournamentUuid}`}
            tourney={tourney}
            shouldHideFavoriteButton={!isUserAlsoPlayer}
            onRefetch={() => router.refresh()}
          />
        );
      })}
    </div>
  ) : (
    <div className='mx-auto max-w-[442px] py-6'>
      <MyModulesNoResults {...noResultsConfig} />
    </div>
  );
}
